import React, { useEffect, useState } from "react";
import { IoWarningOutline } from "react-icons/io5";
import { LuFileBadge } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import Form from "../../../components/Form/Form";
import FormTitle from "../../../components/FormTitle/FormTitle";
import Input from "../../../components/Input/Input";
import Loader from "../../../components/Loader/Loader";
import ModalComponent from "../../../components/Modal/ModalComponent";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";
import TokenGenerator from "../../../components/TokenGenerator/TokenGenerator";
import ClientLicenceService from "../../../services/ClientLicenceService";
import "./FormClientsLicence.css";

function FormClientsLicence(props) {
	const [idClient, setIdClient] = useState(props.licenca?.id_client || null);
	const [dataInicio, setDataInicio] = useState(props.licenca?.start_date);
	const [dataFim, setDataFim] = useState(props.licenca?.end_date);
	const [bindingCode, setBindingCode] = useState(
		props.licenca?.bindingCode || ""
	);
	const [licencaHabilitada, setLicencaHabilitada] = useState(
		props.licenca?.enabled
	);
	const [enableBackup, setEnableBackup] = useState(props.licenca?.enabledBackup);
	const [enabledRotation, setEnabledRotation] = useState(props.licenca?.enabledRotation);
	const [backupSize, setBackupSize] = useState(props.licenca?.backupSize);
	const [token, setToken] = useState(props.licenca?.token_mqtt);
	const [showModalConfirmNewToken, setShowModalConfirmNewToken] =
		useState(false);
	const [showLoader, setShowLoader] = useState(false);

	useEffect(() => {
		setIdClient(props.licenca?.id_client);
		setDataInicio(props.licenca?.start_date);
		setDataFim(props.licenca?.end_date);
		setBindingCode(props.licenca?.bindingCode || "");
		setEnableBackup(props.licenca?.enabledBackup);
		setEnabledRotation(props.licenca?.enabledRotation);
		setBackupSize(props.licenca?.backupSize);
		setLicencaHabilitada(props.licenca?.enabled || false);
		setToken(props.licenca?.token_mqtt || "");
		setShowLoader(false);
	}, [props.licenca]);

	const navigate = useNavigate();

	const buildPayload = () => {
		let payload = {
			id_client: idClient,
			start_date: dataInicio,
			end_date: dataFim,
			bindingCode,
			enabled: licencaHabilitada,
			token_mqtt: token,
			enabledBackup: enableBackup,
			enabledRotation: enabledRotation,
			backupSize,
		};
		return payload;
	};

	async function handleSubmit(event) {
		if (props.type === "edicao") {
			handleEdit(event);
			return;
		}
		event.preventDefault();
		const payload = buildPayload();

		const response = await ClientLicenceService.createClientLicence(payload);
		if (response.data.id) navigate("../consulta-licencas");
	}

	async function handleEdit(event) {
		event.preventDefault();
		const payload = buildPayload();
		const response = await ClientLicenceService.updateClientLicence(
			props.licenca.id,
			payload
		);
		if (response.data.id) navigate("../consulta-licencas");
	}

	async function handleDelete() {
		if (!props.licenca) return;
		await ClientLicenceService.deleteClientLicence(props.licenca.id);
		navigate("../consulta-licencas", {
			state: { deletedId: props.licenca.id },
		});
	}

	const handleClickEditButton = () => {
		if (!props.licenca) return;
		navigate("/cadastro-licencas", { state: props.licenca });
	};

	const handleNewToken = (newToken) => {
		if (token !== "" && props.licenca?.token_mqtt) {
			setShowModalConfirmNewToken(true);
		}
		setToken(newToken);
	};

	const closeModalConfirmNewToken = (action) => {
		setShowModalConfirmNewToken(false);
		if (action === "cancel") {
			setToken(props.licenca.token_mqtt);
		}
	};

	return (
		<React.Fragment>
			<FormTitle
				type={props.type}
				tituloConsulta="Licenças"
				tituloCadastro="Cadastro de Licenças"
				icon={<LuFileBadge size={20} />}
				backRoute={"/consulta-licencas"}
			/>
			{showLoader ? (
				<Loader />
			) : (
				<Form
					handleSubmit={handleSubmit}
					type={props.type}
					handleClickEdit={handleClickEditButton}
					handleDelete={handleDelete}
					navigateCancelUrl={"../consulta-licencas"}
				>
					<div className="form-licenses-container">
						<div className="head-inputs">
							<TokenGenerator
								name={"token"}
								id="token"
								value={token}
								disabled={props.type === "consulta"}
								handleNewToken={(newToken) => handleNewToken(newToken)}
							/>
							<div className="form-code-access-lincense">
								<ToggleButton
									label={`${licencaHabilitada
										? "Licença Habilitada"
										: "Licença Desabilitada"
										}`}
									selected={licencaHabilitada}
									onClick={() => setLicencaHabilitada(!licencaHabilitada)}
									disabled={props.type === "consulta"}
									tooltipVisible={true}
									tooltipText={
										"Habilita ou desabilita a licença, quando desabilitada o cliente não terá acesso ao sistema."
									}
								/>
								<ToggleButton
									label={`${enableBackup ? "Backup Habilitado" : "Backup Desabilitado"
										}`}
									selected={enableBackup}
									onClick={() => setEnableBackup(!enableBackup)}
									disabled={props.type === "consulta"}
									tooltipVisible={true}
									tooltipText={
										"Habilita ou desabilita o backup, quando habilitado o sistema irá realizar backup dos dados do equipamento para o cliente."
									}
								/>
								<ToggleButton
									label={`${enabledRotation ? "Rotação de Backup Habilitada" : "Rotação de Backup Desabilitada"
										}`}
									selected={enabledRotation}
									onClick={() => setEnabledRotation(!enabledRotation)}
									disabled={props.type === "consulta" || !enableBackup}
									tooltipVisible={true}
									tooltipText={
										"Habilita ou desabilita a rotação de backup, quando habilitado, quando o espaço para um novo backup não for suficiente, o mais antigo é removido."
									}
								/>
							</div>
						</div>
						<div className="form-grid-2">
							<div className="form-backup-lincense">
								<Input
									name={"backup_size"}
									id="backup_size"
									labelText={
										enableBackup
											? "Tamanho máximo para backup (Bytes) *"
											: "Tamanho máximo para backup (Bytes)"
									}
									value={backupSize}
									onChange={({ target }) => setBackupSize(target.value)}
									disabled={props.type === "consulta" || !enableBackup}
									required={enableBackup}
									tooltipVisible={true}
									tooltipText={
										"Tamanho máximo para backup, o sistema irá realizar backup dos dados do equipamento para o cliente."
									}
								/>
								<Input
									name={"bindingCode"}
									id="bindingCode"
									labelText={"Código de Vinculação *"}
									value={bindingCode}
									onChange={({ target }) => setBindingCode(target.value)}
									disabled={props.type === "consulta"}
									required={true}
									tooltipVisible={true}
									tooltipText={
										"Código de vinculação da licença com o cliente, aqui pode ser inserido o código de pagamento do cliente."
									}
								/>
								<Input
									name={"start_date"}
									id="start_date"
									type="date"
									labelText={"Data de Início *"}
									value={dataInicio}
									onChange={({ target }) => setDataInicio(target.value)}
									disabled={props.type === "consulta"}
									required={true}
									tooltipVisible={true}
									tooltipText={
										"Data de início da licença, a partir desta data a licença estará habilitada."
									}
								/>
								<Input
									name={"end_date"}
									id="end_date"
									type="date"
									labelText={"Data Fim *"}
									value={dataFim}
									onChange={({ target }) => setDataFim(target.value)}
									disabled={props.type === "consulta"}
									required={true}
									tooltipVisible={true}
									tooltipText={
										"Data de fim da licença, a partir desta data a licença estará desabilitada."
									}
								/>
							</div>
						</div>

						<ModalComponent
							modalIsOpen={showModalConfirmNewToken}
							handleConfirm={() => closeModalConfirmNewToken()}
							handleCancel={() => closeModalConfirmNewToken("cancel")}
							icon={<IoWarningOutline size={30} />}
							modalText={
								"Confimar operação? A conexão com o equipamento será perdida!"
							}
						/>
					</div>
				</Form>
			)}
		</React.Fragment>
	);
}

export default FormClientsLicence;
